// Alpha Vantage Service - Crypto & Stock Prices
// API Key: 1MP2D7YHIE7Q6Y87
// Free tier: 25 requests/day, 5 requests/minute

const ALPHA_VANTAGE_KEY = '1MP2D7YHIE7Q6Y87';
const ALPHA_BASE_URL = 'https://www.alphavantage.co/query';

class AlphaVantageService {
  /**
   * Get crypto price (XRP, BTC, ETH, etc)
   */
  async getCryptoPrice(symbol, market = 'USD') {
    try {
      const response = await fetch(
        `${ALPHA_BASE_URL}?function=CURRENCY_EXCHANGE_RATE&from_currency=${symbol}&to_currency=${market}&apikey=${ALPHA_VANTAGE_KEY}`
      );
      
      const data = await response.json();
      
      if (data['Realtime Currency Exchange Rate']) {
        const rate = data['Realtime Currency Exchange Rate'];
        return {
          success: true,
          symbol: symbol,
          market: market,
          price: parseFloat(rate['5. Exchange Rate']),
          bid: parseFloat(rate['8. Bid Price'] || 0),
          ask: parseFloat(rate['9. Ask Price'] || 0),
          timestamp: rate['6. Last Refreshed']
        };
      }
      
      return {
        success: false,
        error: 'No price data available'
      };
      
    } catch (error) {
      return {
        success: false,
        error: error.message
      };
    }
  }

  /**
   * Get stock price (AAPL, TSLA, etc)
   */
  async getStockPrice(symbol) {
    try {
      const response = await fetch(
        `${ALPHA_BASE_URL}?function=GLOBAL_QUOTE&symbol=${symbol}&apikey=${ALPHA_VANTAGE_KEY}`
      );
      
      const data = await response.json();
      
      if (data['Global Quote']) {
        const quote = data['Global Quote'];
        return {
          success: true,
          symbol: quote['01. symbol'],
          price: parseFloat(quote['05. price']),
          change: parseFloat(quote['09. change']),
          changePercent: quote['10. change percent'],
          volume: parseInt(quote['06. volume']),
          timestamp: quote['07. latest trading day']
        };
      }
      
      return {
        success: false,
        error: 'No stock data available'
      };
      
    } catch (error) {
      return {
        success: false,
        error: error.message
      };
    }
  }

  /**
   * Smart price lookup - detects crypto vs stock
   */
  async getPrice(symbol) {
    // Crypto symbols (common ones)
    const cryptoSymbols = ['BTC', 'ETH', 'XRP', 'ADA', 'SOL', 'DOGE', 'MATIC', 'DOT', 'LINK', 'UNI'];
    
    if (cryptoSymbols.includes(symbol.toUpperCase())) {
      return await this.getCryptoPrice(symbol);
    } else {
      return await this.getStockPrice(symbol);
    }
  }
}

const alphaVantageService = new AlphaVantageService();
export default alphaVantageService;
